export const leaderboardCategoryEnum = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  GRAND: 'GRAND',
  FINAL: 'FINAL',
};
